// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "平法识图",
        "tec": "沈艳丽",
        "week": "1-8周",
        "add": "教学楼D座217经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "何红",
        "week": "12周",
        "add": "教学楼D座328经管"
      }
    ],
    [
      {
        "sub": "工程经济学",
        "tec": "刘龙",
        "week": "1-11,13周",
        "add": "教学楼D座217经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "何红",
        "week": "12周",
        "add": "教学楼D座328经管"
      }
    ],
    {
      "sub": "虚拟设计与施工",
      "tec": "许琳王建宇",
      "week": "1-3,5-9周",
      "add": "教学楼B座117能动机房"
    },
    0,
    0
  ],
  "2": [
    [
      {
        "sub": "工程结构",
        "tec": "慕光波",
        "week": "1-11,13周",
        "add": "教学楼D座217经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "何红",
        "week": "12周",
        "add": "教学楼D座225经管"
      }
    ],
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李健",
        "week": "1-8周",
        "add": "教学楼C座114教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "李健",
        "week": "9-11,13周",
        "add": "教学楼C座114教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "何红",
        "week": "12周",
        "add": "教学楼D座225经管"
      }
    ],
    {
      "sub": "工程项目质量管理",
      "tec": "赵振淇",
      "week": "1-6周",
      "add": "实训楼E座419管理"
    },
    0,
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "高建华张翼",
      "week": "1-8周",
      "add": "教学楼C座212教务"
    }
  ],
  "3": [
    {
      "sub": "工程经济学",
      "tec": "刘龙",
      "week": "1-11,13周",
      "add": "教学楼D座217经管"
    },
    {
      "sub": "工程施工技术与组织",
      "tec": "孙一民",
      "week": "1-11,13周",
      "add": "教学楼D座217经管"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "工程结构",
      "tec": "慕光波",
      "week": "1-11,13周",
      "add": "教学楼D座217经管"
    },
    {
      "sub": "工程项目质量管理",
      "tec": "赵振淇",
      "week": "1-6周",
      "add": "实训楼E座417管理机房"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李健",
        "week": "1-8周",
        "add": "教学楼C座115教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "李健",
        "week": "9-11,13周",
        "add": "教学楼C座115教务"
      }
    ],
    {
      "sub": "虚拟设计与施工",
      "tec": "许琳王建宇",
      "week": "1-3,5-9周",
      "add": "教学楼B座117能动机房"
    },
    0
  ],
  "5": [
    {
      "sub": "平法识图",
      "tec": "沈艳丽",
      "week": "1-8周",
      "add": "教学楼D座217经管"
    },
    {
      "sub": "工程施工技术与组织",
      "tec": "孙一民",
      "week": "1-11,13周",
      "add": "教学楼D座217经管"
    },
    {
      "sub": "就业创业指导",
      "tec": "于瑶",
      "week": "5-9周",
      "add": "教学楼D座317文法"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
